module.exports = __webpack_public_path__ + "static/media/icon-global.4bc4fa11.svg";